export const adminMessages = {
  en: {
    admin: {
      // ── Common ────────────────────────────────────────────────────────────
      noPermission: 'No Permission',
      noPermissionHint: 'You are missing {perm} to view this page.',
      loadingUser: 'Loading user information…',

      // ── Roles ─────────────────────────────────────────────────────────────
      roles: {
        title: 'Roles / Policies',
        addBtn: 'New Role',
        editTooltip: 'Edit',
        permissionsTooltip: 'Assign permissions',
        deleteTooltip: 'Delete',
        colRole: 'Role',
        colDescription: 'Description',
        colPermissions: 'Permissions',
        dialogCreate: 'New Role',
        dialogEdit: 'Edit Role',
        permDialogTitle: 'Permissions for {name}',
        permDialogTitleDefault: 'Assign Permissions',
        permFilterPlaceholder: 'Filter permissions…',
        permCatalogHint: 'Catalog is read-only — new permissions come from the backend.',
        formName: 'Name',
        formNamePlaceholder: 'e.g. SOC Analyst',
        formDescription: 'Description',
        formDescriptionPlaceholder: 'Short description…',
        nameMissing: 'Name must not be empty.',
        saved: 'Saved',
        roleUpdated: 'Role updated.',
        created: 'Created',
        roleCreated: 'Role created.',
        deleted: 'Deleted',
        roleDeleted: 'Role removed.',
        permissionsSaved: 'Permissions assigned.',
        loadFailed: 'Roles could not be loaded.',
        permissionsLoadFailed: 'Permissions could not be loaded.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        permissionsFailed: 'Assignment failed.',
        confirmDelete: 'Really delete role "{name}"?',
      },

      // ── Users ─────────────────────────────────────────────────────────────
      users: {
        title: 'Users',
        addBtn: 'New',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        colName: 'Name',
        colEmail: 'E-Mail',
        colCompany: 'Company',
        colRole: 'Role',
        colActive: 'Active',
        colCreated: 'Created',
        filterAllRoles: 'All Roles',
        filterAll: 'All',
        filterActive: 'Active',
        filterInactive: 'Inactive',
        dialogCreate: 'Create User',
        dialogEdit: 'Edit User',
        formEmail: 'E-Mail',
        formFirstName: 'First Name',
        formLastName: 'Last Name',
        formAvatarUrl: 'Avatar URL',
        formRole: 'Role',
        formRolePlaceholder: 'Select role',
        formCompany: 'Company',
        formCompanyPlaceholder: 'Assign to company',
        noCompany: 'No company',
        formActive: 'Active',
        formPassword: 'Password',
        formPasswordEdit: 'Password (leave blank = unchanged)',
        statusActive: 'active',
        statusInactive: 'inactive',
        validationFirstName: 'First name is required.',
        validationLastName: 'Last name is required.',
        validationEmail: 'E-Mail is required.',
        validationRole: 'Role is required.',
        validationPassword: 'Password is required (min. 8 characters).',
        saved: 'Saved',
        userUpdated: 'User updated.',
        created: 'Created',
        userCreated: 'User created.',
        userCreatedInvite: 'Invite sent to {email}.',
        modeLabel: 'How should the user receive their password?',
        modeInvite: 'Send invite link',
        modeManual: 'Set password manually',
        modeInviteHint: 'The user gets an email with an activation link, valid for 72 hours, and chooses their own password on first login.',
        modeManualHint: 'You set the password now and share it with the user via a separate, secure channel.',
        createAndInvite: 'Create & send invite',
        deleted: 'Deleted',
        userDeleted: 'User removed.',
        loadFailed: 'Users could not be loaded.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        confirmDelete: 'Really delete user "{email}"?',
      },

      // ── API Keys ──────────────────────────────────────────────────────────
      apiKeys: {
        title: 'API Keys',
        addBtn: 'New',
        revokeTooltip: 'Revoke',
        colPrefix: 'Prefix',
        colLabel: 'Label',
        colScopes: 'Scopes',
        colUserId: 'User',
        colStatus: 'Status',
        colCreated: 'Created',
        colLastUsed: 'Last Used',
        colExpires: 'Expires',
        filterAll: 'All',
        filterActive: 'Active',
        filterRevoked: 'Revoked',
        statusActive: 'active',
        statusRevoked: 'revoked',
        dialogCreate: 'Create API Key',
        dialogCreated: 'API Key Created',
        formLabel: 'Label',
        formLabelPlaceholder: 'e.g. CI/CD, Service X',
        formUserId: 'User-ID (optional)',
        formUserIdPlaceholder: 'e.g. 42',
        formScopes: 'Scopes',
        formScopesPlaceholder: 'e.g. siem:read, siem:write',
        formExpires: 'Expiry date (optional)',
        createBtn: 'Create',
        copyBtn: 'Copy',
        closeBtn: 'Close',
        plainKeyHint: 'This is your <strong>one-time visible</strong> API Key. Copy it now to a safe location.',
        created: 'Created',
        keyCreated: 'API Key created.',
        revoked: 'Revoked',
        keyRevoked: 'API Key deactivated.',
        copied: 'Copied',
        keyCopied: 'API Key copied to clipboard.',
        copyFailed: 'Could not copy to clipboard.',
        loadFailed: 'API Keys could not be loaded.',
        createFailed: 'Create failed.',
        revokeFailed: 'Revoke failed.',
        patchFailed: 'Update failed.',
        confirmRevoke: 'Really REVOKE API Key "{label}"?',
        editTooltip: 'Edit scopes / label',
        alreadyRevoked: 'This key is already revoked.',
        dialogEdit: 'Edit API Key',
        editBtn: 'Save',
        patched: 'Saved',
        keyPatched: 'API Key updated.',
        formSuggestedScopes: 'Recommended scopes',
        mcpScopesHint: 'Recommended for MCP server',
      },

      // ── Audit Logs ───────────────────────────────────────────────────────
      auditLogs: {
        title: 'Audit Logs',
        colTime: 'Time',
        colAction: 'Action',
        colUser: 'User',
        colStatus: 'Status',
        colTargetType: 'Type',
        colTargetId: 'Target ID',
        colIp: 'IP',
        colUserAgent: 'User Agent',
        filterAllActions: 'All Actions',
        filterAllStatuses: 'All Statuses',
        filterFrom: 'From',
        filterTo: 'To',
        resetFilters: 'Reset filters',
        statusSuccess: 'success',
        statusError: 'error',
        loadFailed: 'Audit logs could not be loaded.',
      },

      // ── Companies ─────────────────────────────────────────────────────────
      companies: {
        title: 'Companies',
        addBtn: 'New',
        editTooltip: 'Edit',
        deleteTooltip: 'Delete',
        colId: 'ID',
        colName: 'Name',
        colIndustry: 'Industry',
        colCity: 'City',
        colCountry: 'Country',
        colUsers: 'Users',
        colType: 'Type',
        colCustomer: 'Customer',
        colDescription: 'Description',
        tabGeneral: 'General',
        tabAddress: 'Address',
        tabDetails: 'Details',
        tagCustomer: 'Customer',
        tagPartner: 'Partner',
        customer: 'Customer',
        nameRequired: 'Company name is required.',
        dialogCreate: 'Add Company',
        dialogEdit: 'Edit Company',
        formName: 'Name',
        formIndustry: 'Industry',
        formDescription: 'Description',
        formAddress: 'Address',
        formZip: 'ZIP',
        formCity: 'City',
        formState: 'State',
        formCountry: 'Country',
        formPhone: 'Phone',
        formWebsite: 'Website',
        formEmployees: 'Employee Count',
        formFounded: 'Founded Date',
        formPartnerId: 'Partner Company ID',
        formCustomer: 'Enginsight Customer',
        formPartner: 'Enginsight Partner',
        saved: 'Saved',
        companyCreated: 'Company created.',
        companyUpdated: 'Company updated.',
        deleted: 'Deleted',
        companyDeleted: 'Company removed.',
        loadFailed: 'Companies could not be loaded.',
        saveFailed: 'Save failed.',
        deleteFailed: 'Delete failed.',
        confirmDelete: 'Really delete company "{name}"?',
        filterIndustry:    'Industry',
        filterIndustryAll: 'All industries',
      },

      // ── System Status ──────────────────────────────────────────────────────
      status: {
        title:        'System Status',
        overall_ok:   'All systems operational',
        overall_deg:  'Service degraded',
        checkedAt:    'Checked at',
        refresh:      'Refresh',
        version:      'Version',
        latency:      'Latency',
        streams:      'Streams',
        db_size:      'DB Size',
        connections:  'Connections',
        loadFailed:   'Could not load system status.',
        svc_ok:         'Online',
        svc_down:       'Offline',
        svc_deployed:   'Deployed',
        group_services: 'Services',
        group_helper:   'Helper',
        last_sync:      'Last Sync',
        schema_title: 'Version Scheme',
        schema_desc:  'Each service is versioned independently following MAJOR.MINOR.BUILD — a hotfix can advance only one service while others stay on the same version.',
        schema_major: 'Breaking changes or large new feature sets',
        schema_minor: 'Improvements and additions within a release',
        schema_build: 'Hotfixes and bug patches',
      },
    },
  },
  de: {
    admin: {
      noPermission: 'Keine Berechtigung',
      noPermissionHint: 'Dir fehlt {perm}, um diese Seite zu sehen.',
      loadingUser: 'Lade Benutzerinformationen …',

      roles: {
        title: 'Rollen / Policies',
        addBtn: 'Neue Rolle',
        editTooltip: 'Bearbeiten',
        permissionsTooltip: 'Rechte zuweisen',
        deleteTooltip: 'Löschen',
        colRole: 'Rolle',
        colDescription: 'Beschreibung',
        colPermissions: 'Rechte',
        dialogCreate: 'Neue Rolle',
        dialogEdit: 'Rolle bearbeiten',
        permDialogTitle: 'Rechte für {name}',
        permDialogTitleDefault: 'Rechte zuweisen',
        permFilterPlaceholder: 'Permissions filtern…',
        permCatalogHint: 'Katalog ist read-only – neue Permissions kommen aus dem Backend.',
        formName: 'Name',
        formNamePlaceholder: 'z. B. SOC Analyst',
        formDescription: 'Beschreibung',
        formDescriptionPlaceholder: 'Kurzbeschreibung…',
        nameMissing: 'Name darf nicht leer sein.',
        saved: 'Gespeichert',
        roleUpdated: 'Rolle aktualisiert.',
        created: 'Erstellt',
        roleCreated: 'Rolle angelegt.',
        deleted: 'Gelöscht',
        roleDeleted: 'Rolle entfernt.',
        permissionsSaved: 'Rechte zugewiesen.',
        loadFailed: 'Rollen konnten nicht geladen werden.',
        permissionsLoadFailed: 'Permissions konnten nicht geladen werden.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        permissionsFailed: 'Zuweisung fehlgeschlagen.',
        confirmDelete: 'Rolle "{name}" wirklich löschen?',
      },

      users: {
        title: 'Benutzer',
        addBtn: 'Neu',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        colName: 'Name',
        colEmail: 'E-Mail',
        colCompany: 'Unternehmen',
        colRole: 'Rolle',
        colActive: 'Aktiv',
        colCreated: 'Erstellt',
        filterAllRoles: 'Alle Rollen',
        filterAll: 'Alle',
        filterActive: 'Aktiv',
        filterInactive: 'Inaktiv',
        dialogCreate: 'Benutzer anlegen',
        dialogEdit: 'Benutzer bearbeiten',
        formEmail: 'E-Mail',
        formFirstName: 'Vorname',
        formLastName: 'Nachname',
        formAvatarUrl: 'Avatar URL',
        formRole: 'Rolle',
        formRolePlaceholder: 'Rolle wählen',
        formCompany: 'Unternehmen',
        formCompanyPlaceholder: 'Unternehmen zuweisen',
        noCompany: 'Kein Unternehmen',
        formActive: 'Aktiv',
        formPassword: 'Passwort',
        formPasswordEdit: 'Passwort (leer lassen = unverändert)',
        statusActive: 'aktiv',
        statusInactive: 'inaktiv',
        validationFirstName: 'Vorname ist erforderlich.',
        validationLastName: 'Nachname ist erforderlich.',
        validationEmail: 'E-Mail ist erforderlich.',
        validationRole: 'Rolle ist erforderlich.',
        validationPassword: 'Passwort ist erforderlich (mind. 8 Zeichen).',
        saved: 'Gespeichert',
        userUpdated: 'Benutzer aktualisiert.',
        created: 'Erstellt',
        userCreated: 'Benutzer angelegt.',
        userCreatedInvite: 'Einladung an {email} gesendet.',
        modeLabel: 'Wie soll der Benutzer sein Passwort erhalten?',
        modeInvite: 'Einladungslink senden',
        modeManual: 'Passwort manuell festlegen',
        modeInviteHint: 'Der Benutzer bekommt per Mail einen Aktivierungslink (gültig 72 Stunden) und legt sein Passwort beim ersten Login selbst fest.',
        modeManualHint: 'Du legst das Passwort jetzt fest und übergibst es dem Benutzer auf einem separaten, sicheren Kanal.',
        createAndInvite: 'Anlegen & einladen',
        deleted: 'Gelöscht',
        userDeleted: 'Benutzer entfernt.',
        loadFailed: 'Benutzer konnten nicht geladen werden.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        confirmDelete: 'Benutzer "{email}" wirklich löschen?',
      },

      apiKeys: {
        title: 'API Keys',
        addBtn: 'Neu',
        revokeTooltip: 'Revoke',
        colPrefix: 'Prefix',
        colLabel: 'Label',
        colScopes: 'Scopes',
        colUserId: 'User',
        colStatus: 'Status',
        colCreated: 'Erstellt',
        colLastUsed: 'Letzte Nutzung',
        colExpires: 'Ablauf',
        filterAll: 'Alle',
        filterActive: 'Aktiv',
        filterRevoked: 'Revoked',
        statusActive: 'aktiv',
        statusRevoked: 'revoked',
        dialogCreate: 'API Key erstellen',
        dialogCreated: 'API Key erstellt',
        formLabel: 'Label',
        formLabelPlaceholder: 'z. B. CI/CD, Service X',
        formUserId: 'User-ID (optional)',
        formUserIdPlaceholder: 'z. B. 42',
        formScopes: 'Scopes',
        formScopesPlaceholder: 'z. B. siem:read, siem:write',
        formExpires: 'Ablaufdatum (optional)',
        createBtn: 'Erstellen',
        copyBtn: 'Kopieren',
        closeBtn: 'Schliessen',
        plainKeyHint: 'Dies ist dein <strong>einmalig</strong> angezeigter API Key. Kopiere ihn jetzt sicher an einen geschützten Ort.',
        created: 'Erstellt',
        keyCreated: 'API Key wurde erzeugt.',
        revoked: 'Revoked',
        keyRevoked: 'API Key wurde deaktiviert.',
        copied: 'Kopiert',
        keyCopied: 'API Key in die Zwischenablage kopiert.',
        copyFailed: 'Konnte nicht in die Zwischenablage kopieren.',
        loadFailed: 'API-Keys konnten nicht geladen werden.',
        createFailed: 'Erstellen fehlgeschlagen.',
        revokeFailed: 'Revoke fehlgeschlagen.',
        patchFailed: 'Aktualisierung fehlgeschlagen.',
        confirmRevoke: 'API Key "{label}" wirklich REVOKEN?',
        editTooltip: 'Scopes / Label bearbeiten',
        alreadyRevoked: 'Dieser Key ist bereits widerrufen.',
        dialogEdit: 'API Key bearbeiten',
        editBtn: 'Speichern',
        patched: 'Gespeichert',
        keyPatched: 'API Key wurde aktualisiert.',
        formSuggestedScopes: 'Empfohlene Scopes',
        mcpScopesHint: 'Empfohlen für MCP-Server',
      },

      // ── Audit Logs ───────────────────────────────────────────────────────
      auditLogs: {
        title: 'Audit Logs',
        colTime: 'Zeitpunkt',
        colAction: 'Aktion',
        colUser: 'Benutzer',
        colStatus: 'Status',
        colTargetType: 'Typ',
        colTargetId: 'Ziel-ID',
        colIp: 'IP',
        colUserAgent: 'User Agent',
        filterAllActions: 'Alle Aktionen',
        filterAllStatuses: 'Alle Status',
        filterFrom: 'Von',
        filterTo: 'Bis',
        resetFilters: 'Filter zurücksetzen',
        statusSuccess: 'Erfolg',
        statusError: 'Fehler',
        loadFailed: 'Audit Logs konnten nicht geladen werden.',
      },

      companies: {
        title: 'Unternehmen',
        addBtn: 'Neu',
        editTooltip: 'Bearbeiten',
        deleteTooltip: 'Löschen',
        colId: 'ID',
        colName: 'Name',
        colIndustry: 'Branche',
        colCity: 'Stadt',
        colCountry: 'Land',
        colUsers: 'Benutzer',
        colType: 'Typ',
        colCustomer: 'Kunde',
        colDescription: 'Beschreibung',
        tabGeneral: 'Allgemein',
        tabAddress: 'Adresse',
        tabDetails: 'Details',
        tagCustomer: 'Kunde',
        tagPartner: 'Partner',
        customer: 'Kunde',
        nameRequired: 'Unternehmensname ist erforderlich.',
        dialogCreate: 'Unternehmen hinzufügen',
        dialogEdit: 'Unternehmen bearbeiten',
        formName: 'Name',
        formIndustry: 'Branche',
        formDescription: 'Beschreibung',
        formAddress: 'Adresse',
        formZip: 'PLZ',
        formCity: 'Stadt',
        formState: 'Bundesland',
        formCountry: 'Land',
        formPhone: 'Telefon',
        formWebsite: 'Website',
        formEmployees: 'Mitarbeiterzahl',
        formFounded: 'Gründungsdatum',
        formPartnerId: 'Partner-Company ID',
        formCustomer: 'Enginsight Kunde',
        formPartner: 'Enginsight Partner',
        saved: 'Gespeichert',
        companyCreated: 'Unternehmen wurde erstellt.',
        companyUpdated: 'Unternehmen wurde aktualisiert.',
        deleted: 'Gelöscht',
        companyDeleted: 'Unternehmen wurde entfernt.',
        loadFailed: 'Unternehmen konnten nicht geladen werden.',
        saveFailed: 'Speichern fehlgeschlagen.',
        deleteFailed: 'Löschen fehlgeschlagen.',
        confirmDelete: 'Unternehmen "{name}" wirklich löschen?',
        filterIndustry:    'Branche',
        filterIndustryAll: 'Alle Branchen',
      },

      // ── System Status ──────────────────────────────────────────────────────
      status: {
        title:        'Systemstatus',
        overall_ok:   'Alle Systeme betriebsbereit',
        overall_deg:  'Service beeinträchtigt',
        checkedAt:    'Geprüft am',
        refresh:      'Aktualisieren',
        version:      'Version',
        latency:      'Latenz',
        streams:      'Streams',
        db_size:      'DB-Größe',
        connections:  'Verbindungen',
        loadFailed:   'Systemstatus konnte nicht geladen werden.',
        svc_ok:         'Online',
        svc_down:       'Offline',
        svc_deployed:   'Deployed',
        group_services: 'Services',
        group_helper:   'Helper',
        last_sync:      'Letzter Sync',
        schema_title: 'Versionierungsschema',
        schema_desc:  'Jeder Service wird unabhängig nach MAJOR.MINOR.BUILD versioniert — ein Hotfix kann einzelne Services voranschreiten lassen, während alle anderen auf ihrer Version bleiben.',
        schema_major: 'Breaking Changes oder große neue Feature-Sets',
        schema_minor: 'Verbesserungen und Erweiterungen innerhalb eines Releases',
        schema_build: 'Hotfixes und Bugfixes',
      },
    },
  },
}
